"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _templateObject;
var Wrapper = exports.Wrapper = (0, _styledComponents["default"])(_reactstrap.Container)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n"])));